module.exports = __webpack_public_path__ + "img/features_icon_3.e1771280.svg";